<template>
  <div class="w-full py-3 block lg:hidden"
    v-if="broker != null"
    :style="'background-color:' + (broker.header_background != null ? broker.header_background : '#1A356F') + ';'">

    <div class="flex items-center justify-between w-full px-6 xxl:px-6 xxl:w-3/5 m-auto">
      <template v-if="broker.logo != null">
        <BrokerLogo v-bind:broker="broker" />
      </template>
      <template v-else>
        <BrokerpadLogo />
      </template>

      <div class="flex items-center">        
        <template v-if="broker.profile_image != null">
          <img :src="broker.profile_image.url" class="rounded-full w-12 inline mr-4" />
        </template>
        <template v-else>
          <img src="https://img.icons8.com/color/48/000000/test-account.png" class="rounded-full w-12 mr-4 inline" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import BrokerLogo     from '@/shared/components/BrokerLogo';
  import BrokerpadLogo  from '@/shared/components/BrokerpadLogo';

  export default {

    components: {
      BrokerpadLogo,
      BrokerLogo
    },

    computed : {

      broker() {
        if(this.$route.params.brokerId != this.$store.state[this.$store.state.view + 'Module'].broker.id && this.$route.name == 'broker-site-appearance') {
          return this.$store.state[this.$store.state.view + 'Module'].brokerViaAdmin
        } else {
          return this.$store.state[this.$store.state.view + 'Module'].broker
        }
      },
    },
  }
</script>